module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "playList"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playListToggle),
      expression: "playListToggle"
    }],
    staticClass: "play-list-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playListToggle),
      expression: "playListToggle"
    }],
    staticClass: "playListMask",
    on: {
      "click": function($event) {
        _vm.hide()
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "playList",
    staticClass: "play-list"
  }, [_c('div', {
    staticClass: "playList-header border-1px"
  }, [_c('mode', {
    attrs: {
      "title": true,
      "size": "22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear",
    on: {
      "click": function($event) {
        _vm.clear()
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v("清空\n                        ")])], 1), _vm._v(" "), _c('scroll', {
    ref: "scroll",
    attrs: {
      "data": _vm.items
    }
  }, [_c('ul', _vm._l((_vm.items), function(item) {
    return _c('li', {
      key: item.song_id,
      staticClass: "list border-1px",
      class: {
        active: _vm.songId === item.song_id
      },
      on: {
        "click": function($event) {
          _vm.fileLink(item)
        }
      }
    }, [(_vm.songId === item.song_id) ? _c('i', {
      staticClass: "iconfont"
    }, [_vm._v("")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v("\n                                    " + _vm._s(item.title || item.songname) + "\n                                ")]), _vm._v("\n                                -\n                                "), _c('span', {
      staticClass: "artistname",
      domProps: {
        "innerHTML": _vm._s(item.author || item.artistname)
      }
    })])
  }))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5900b36e"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/playList/playList.vue
// module id = 206
// module chunks = 1